/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class RegisterRoute extends Route {
  // Attrs
  @service
  store;

  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
  };

  // State
  // dateFrom provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateFrom = moment().format('YYYY-MM-DD');

  // dateTo provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateTo = moment().format('YYYY-MM-DD');

  model(params) {
    let dateFrom = params.dateFrom || this.dateFrom;
    let dateTo = params.dateTo || this.dateTo;

    return hash({
      sickbayPage: this.store
        .peekAll('posts/page')
        .find((page) => page.isSickbay === true),
      sickbayVisits: this.store.query('attendance/sickbay-visit', {
        dateFrom,
        dateTo,
      }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
    });
  }
}
